export default __webpack_public_path__ + "static/media/newsLetterbg.ca3443da.svg";